export const ru = {
    checkin_from: 'Заселение с',
    checkout_before: 'Выезд до',
    guests_count: {
        one: 'Цена за {count} гостя',
        some: 'Цена за {count} гостей',
        many: 'Цена за {count} гостей',
    },
};
